const styles = (theme) => ({
  tooltipList: {
    listStyle: 'none',
    padding: '0 10px 0 0',
    margin: '10px 0',
    maxHeight: 125,
    overflowY: 'auto',
    fontSize: theme.typography.pxToRem(11),
  },
});

export default styles;
